{
  "tags": {
    "new": "Nouveau",
    "guaranteed": "Garanti"
  },
  "claim": "Réclamer",
  "claimed": "Réclamée",
  "progress": "Progression : {{title}}",
  "rewardUnavailable": "Récompense indisponible",
  "rewardFor": "{{parts}} pour {{name}}",
  "rewardNamed": "{{parts}} : {{name}}",
  "forName": "pour {{name}}",
  "choiceCard": "sur une carte au choix",
  "xp": "+{{xp}} EXP",
  "cards": {
    "which": "Quelle carte ?",
    "place_one": "{{count}} fragments à poser sur une carte que tu possèdes.",
    "place_other": "{{count}} fragments à poser sur une carte que tu possèdes.",
    "search": "Chercher une carte…",
    "emptyTitle": "Aucune carte",
    "emptyBody": "Obtiens d’abord un personnage, puis reviens poser ces fragments."
  },
  "boosters": {
    "title": "Le comptoir des boosters",
    "intro": "Choisis ton paquet, consulte ses garanties et découvre tes prochaines cartes.",
    "openFailed": "Ouverture impossible",
    "type": "Type de booster",
    "unavailable": "Indisponible",
    "giftedBadge_one": "{{count}} offert",
    "giftedBadge_other": "{{count}} offerts",
    "preview": "Aperçu du {{name}}",
    "quantity": "Nombre de boosters",
    "openOne": "Ouvrir 1 booster",
    "openTen": "Ouvrir 10 boosters",
    "openMax_one": "Ouvrir le maximum ({{count}} booster)",
    "openMax_other": "Ouvrir le maximum ({{count}} boosters)",
    "openMaxUnavailable": "Ouvrir le maximum (indisponible)",
    "max": "Max",
    "maxCount": "Max ×{{count}}",
    "opening": "Ouverture…",
    "openFree": "Ouvrir gratuitement",
    "open": "Ouvrir",
    "openCount": "Ouvrir ×{{count}}",
    "reserveEmptyIn": "Réserve vide. Le prochain booster arrive dans {{time}}.",
    "reserveEmptySoon": "Réserve vide. Le prochain booster arrive bientôt.",
    "giftedHint_one": "{{formatted}} booster offert, sans dépenser d’Anima",
    "giftedHint_other": "{{formatted}} boosters offerts, sans dépenser d’Anima",
    "unavailableNow": "Indisponible pour le moment.",
    "shortfall": "Il te manque {{amount}} Anima. Les <link>quêtes</link> peuvent rapporter des boosters.",
    "xp_one": "+{{xp}} EXP pour cette ouverture.",
    "xp_other": "+{{xp}} EXP pour ces {{count}} ouvertures.",
    "odds": "Probabilités",
    "reserve": "Réserve {{charges}}/{{max}}",
    "reserveFull": "Réserve pleine",
    "nextCharge": "+1 dans {{time}}",
    "recharging": "Recharge en cours",
    "reserveCap": "Max {{max}} (10 + niveau). Recharge complète en 1 h.",
    "history": "Dernières ouvertures",
    "free": "Gratuit",
    "duplicateDisplay": "Doublons à l’ouverture",
    "duplicateAsCard": "Carte",
    "duplicateAsFragment": "Fragments"
  },
  "reveal": {
    "noNew": "Aucun nouveau personnage",
    "newCharacters_one": "{{count}} nouveau personnage",
    "newCharacters_other": "{{count}} nouveaux personnages",
    "noDuplicates": "aucun doublon",
    "duplicates_one": "{{count}} doublon converti en {{fragments}} fragments",
    "duplicates_other": "{{count}} doublons convertis en {{fragments}} fragments",
    "summary": "{{fresh}}, {{converted}}.",
    "added": "Nouveau personnage ajouté à ta collection",
    "converted": "Doublon converti en {{gained}} fragments ({{total}} au total)",
    "pity": "Garantie de pitié : {{rarity}} ou mieux",
    "opening": "Ouverture : {{name}}",
    "cardOf": "Carte {{current}} sur {{total}}",
    "cardContinue": "{{name}}, {{rarity}}. {{action}}",
    "flipCard": "Retourner la carte",
    "flipHint": "Touche la carte pour la retourner",
    "nextCard": "Carte suivante",
    "seeResult": "Voir le résultat",
    "flip": "Retourner",
    "revealAll": "Tout révéler",
    "animeCompleted": "Œuvre complétée",
    "balance": "Solde",
    "finish": "Terminer",
    "openAgain": "Ouvrir à nouveau",
    "achievementsReached_one": "Succès débloqué !",
    "achievementsReached_other": "{{count}} succès débloqués !",
    "tierReady": "Palier {{tier}} atteint",
    "tiersReady": "Paliers {{from}} à {{to}} atteints",
    "claimAchievements": "Réclamer mes succès",
    "skip": "Passer",
    "fragmentsLabel": "fragments",
    "duplicateTile": "{{name}}, {{rarity}}, doublon : +{{gained}} fragments ({{total}} au total)"
  },
  "rates": {
    "rarity": "Rareté",
    "probability": "Probabilité",
    "fragments": "Fragments",
    "guarantees": "Garanties",
    "orBetter": "{{rarity}} ou mieux",
    "counter": "Compteur de garantie {{rarity}}",
    "next": "Garanti à la prochaine ouverture",
    "within_one": "Garanti au plus tard dans {{count}} ouverture",
    "within_other": "Garanti au plus tard dans {{count}} ouvertures",
    "live": "Ces taux sont fixés dans la configuration du jeu : ils ne dépendent pas de la taille du catalogue."
  },
  "harvest": {
    "howTitle": "Comment la cagnotte est-elle partagée ?",
    "pageTitle": "Moisson d’Anima",
    "intro": "Ouvre des boosters pour participer à la cagnotte du mois.",
    "bannerAlt": "Moisson d’Anima : ouverture de boosters et cagnotte partagée",
    "ends": "Partage dans {{time}}",
    "ruleBefore": "Les frais de {{saleFee}} % des ventes, des enchères et des échanges remplissent cette cagnotte. Une reprise par le système y verse {{buybackPot}} % de son prix ({{buyback}} % de la valeur de la carte). Un booster gratuit y ajoute",
    "ruleAfter": ", et un booster payant y ajoute {{saleFee}} % de son prix (arrondi au supérieur). À la fin du mois, elle est entièrement redistribuée entre les joueurs qui ont ouvert des boosters, selon leur part des ouvertures.",
    "yours": "Ta participation",
    "opened": "Ouverts",
    "share": "Part",
    "place": "Place",
    "estimated": "Estimée",
    "none": "Tu n’as pas encore ouvert de booster ce mois-ci. <link>Ouvre-en un</link> pour entrer dans le partage.",
    "ranking": "Classement",
    "boosterCount_one": "{{formatted}} booster",
    "boosterCount_other": "{{formatted}} boosters",
    "waiting": "Personne n’a encore ouvert de booster. La cagnotte attend.",
    "outside_one": "Tu es {{place}} avec {{openings}} booster, soit {{share}}",
    "outside_other": "Tu es {{place}} avec {{openings}} boosters, soit {{share}}",
    "last": "Dernière moisson",
    "previousMonth": "{{month}} :",
    "previousShared_one": "partagés entre {{openings}} booster.",
    "previousShared_other": "partagés entre {{openings}} boosters.",
    "yourCut": "Ta part :"
  },
  "quests": {
    "title": "Quêtes et succès",
    "claimable_one": "{{count}} à réclamer",
    "claimable_other": "{{count}} à réclamer",
    "endsIn": "Fin dans {{time}}",
    "newIn": "Nouvelles dans {{time}}",
    "achievementsIntro": "Chaque succès monte par paliers, sans fin : l’objectif et la récompense grossissent à chaque palier. Rien n’est versé tout seul, viens récupérer tes paliers. Tous les 5 paliers, un cosmétique unique à équiper.",
    "intro": "Quatre quêtes par jour, quatre plus grosses sur 7 jours et trois grandes quêtes sur le mois. La récompense est tirée au sort, et l’objectif suit ce qu’elle vaut. Une quête ne te plaît pas ? Tu peux en changer une par période.",
    "category": "Catégorie",
    "day": "Jour",
    "week": "Semaine",
    "achievements": "Succès",
    "endsHint": "Ces quêtes se terminent dans {{time}}.",
    "renewHint": "Ces quêtes se renouvellent dans {{time}}.",
    "done": "Quête terminée : {{title}}",
    "reroll": "Changer",
    "rerollFailed": "Impossible de changer cette quête",
    "filterAll": "Tous",
    "filterReady": "À récupérer",
    "noneReady": "Aucun palier à récupérer pour l’instant."
  },
  "achievements": {
    "xp": "points d’expérience",
    "tier": "Palier {{tier}}",
    "tierTitle": "{{title}} — palier {{tier}}",
    "claimedTiers_one": "{{count}} palier récupéré",
    "claimedTiers_other": "{{count}} paliers récupérés",
    "claim": "Récupérer",
    "claimMany": "Récupérer (×{{count}})"
  },
  "calendar": {
    "todayTitle": "Ta récompense du jour",
    "legend": { "anima": "Anima", "fragments": "Fragments", "boosters": "Boosters", "cards": "Personnages" },
    "title": "Calendrier",
    "combo": "Combo {{count}}",
    "monthBonus": " · +{{percent}} % ce mois",
    "nextBonus": " · mois prochain +{{percent}} %",
    "ready": "Récompense prête",
    "newDay": "Nouveau jour dans {{time}}",
    "month": "Mois {{month}}",
    "grid": "Calendrier du mois",
    "day": "Jour {{day}}, {{kind}}{{amount}}, {{status}}",
    "amount": ", {{amount}}",
    "today": "Connexion du jour",
    "weekdays": {
      "mon": "L",
      "tue": "M",
      "wed": "M",
      "thu": "J",
      "fri": "V",
      "sat": "S",
      "sun": "D"
    },
    "kinds": {
      "fragments": "Fragments",
      "anima": "Anima",
      "booster_standard": "Booster Standard",
      "booster_premium": "Booster Premium",
      "booster_legendary": "Booster Chanceux",
      "character_legendary": "Personnage légendaire",
      "character_mythic": "Personnage mythique",
      "character_divine": "Personnage divin"
    },
    "status": {
      "claimed": "réclamé",
      "missed": "manqué",
      "claimable": "à réclamer",
      "locked": "verrouillé"
    }
  }
}
